import { withStyles } from '@material-ui/core';
import Label from '../../common/Label';
import Value from '../../common/Value';
import { formatAddress } from '../../../../utils/utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  consigneeValue: {
    fontSize: theme.headerTextFontSize,
    marginBottom: 4
  },
  consigneeDetailContainer: {
    margin: '8px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: 16
  }
});
const ConsigneeDetails = ({ classes, proData }) => {
  const consigneeName = proData.consigneeName;
  const consigneeAddress = formatAddress({
    address: proData.consigneeAddress1,
    address2: proData.consigneeAddress2,
    city: proData.consigneeCity,
    state: proData.consigneeState,
    zip: proData.consigneeZip,
    country: proData.consigneeCountry
  });
  return (
    <div className={classes.container}>
      <Label labelText="CONSIGNEE DETAILS" />
      <div className={classes.consigneeDetailContainer}>
        {(consigneeName || consigneeAddress) ? (
          <>
            <Value value={consigneeName} customClasses={classes.consigneeValue} />
            <Value value={consigneeAddress} />
          </>
        ) : <Value value='NA'/>}
      </div>
    </div>
  );
};

export default withStyles(styles)(ConsigneeDetails);
